import React from "react";

import { PDFPreviewContainer } from "./PDFPreviewContainer";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { PDFIframePreview } from "@/features/LiveFormEditor/LivePreview/shared/PDFIframePreview";

export interface PDFPreviewProps {
  children: React.ReactNode;
  iframeRef?: React.RefObject<HTMLIFrameElement | null>;
  onLoad?: () => void;
  dataTest?: string;
  title: string;
}

/**
 * PDFPreview is a composed wrapper that combines PDFPreviewContainer and PDFIframePreview.
 * Use this for a one-liner PDF preview with standard layout and iframe rendering.
 *
 * children: React.ReactNode (the content to render inside the iframe)
 */
export const PDFPreview: React.FC<PDFPreviewProps> = ({ children, iframeRef, onLoad, dataTest, title }) => (
  <PDFPreviewContainer>
    <PDFIframePreview iframeRef={iframeRef} onLoad={onLoad} dataTest={dataTest} title={title}>
      {children}
    </PDFIframePreview>
  </PDFPreviewContainer>
);
